import React, { ReactElement } from 'react';
import cx from 'classnames';

export interface ConfirmationModalProps {
  onClose?: () => void;
  onConfirm?: () => void;
  description?: string;
  title?: string;
  buttonName?: string;
  buttonClassName?: string;
}

export const ConfirmationModal = ({
  onClose = () => {},
  onConfirm = () => {},
  description,
  title,
  buttonName = 'Change',
  buttonClassName
}: ConfirmationModalProps): ReactElement => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <div className="confirmation-modal">
      {title && <div className="confirmation-title">{title}</div>}
      <div className="confirmation-description">{description}</div>
      <div className="button-container">
        <span className={cx('modal-button', 'confirm', buttonClassName)} onClick={handleConfirm}>
          {buttonName}
        </span>
        <div className="modal-button" onClick={onClose}>
          Cancel
        </div>
      </div>
    </div>
  );
};
